import {
  ApiResponse,
  Intelligence,
  Stats,
  MiningJob,
  ListFilter,
} from "../types/intelligence";

const API_BASE = "/api/v1";

async function fetchApi<T>(
  endpoint: string,
  options?: RequestInit,
): Promise<ApiResponse<T>> {
  try {
    const response = await fetch(`${API_BASE}${endpoint}`, {
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
      ...options,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : "Unknown error occurred",
    };
  }
}

export const api = {
  // Intelligence
  async listIntelligence(
    filter?: ListFilter,
  ): Promise<ApiResponse<Intelligence[]>> {
    const params = new URLSearchParams();
    if (filter?.page) params.set("page", filter.page.toString());
    if (filter?.limit) params.set("limit", filter.limit.toString());
    if (filter?.min_score) params.set("min_score", filter.min_score.toString());
    if (filter?.keyword) params.set("keyword", filter.keyword);
    if (filter?.has_github !== undefined)
      params.set("has_github", filter.has_github.toString());
    if (filter?.sort_by) params.set("sort_by", filter.sort_by);
    const query = params.toString() ? `?${params.toString()}` : "";
    return fetchApi<Intelligence[]>(`/intelligence${query}`);
  },

  async getIntelligenceById(id: number): Promise<ApiResponse<Intelligence>> {
    return fetchApi<Intelligence>(`/intelligence/${id}`);
  },

  async getTopIntelligence(limit = 10): Promise<ApiResponse<Intelligence[]>> {
    return fetchApi<Intelligence[]>(`/intelligence/top?limit=${limit}`);
  },

  async getStats(): Promise<ApiResponse<Stats>> {
    return fetchApi<Stats>("/stats");
  },

  // Admin
  async triggerMining(): Promise<ApiResponse<MiningJob>> {
    return fetchApi<MiningJob>("/admin/mine", { method: "POST" });
  },

  async getMiningStatus(): Promise<ApiResponse<MiningJob>> {
    return fetchApi<MiningJob>("/admin/mine/status");
  },

  // Health
  async healthCheck(): Promise<{
    status: string;
    version: string;
    uptime: string;
    timestamp: string;
  }> {
    const response = await fetch("/health");
    return response.json();
  },
};

export default api;
